import { SVGProps, Ref, forwardRef } from 'react';

export const TinkoffIdBrandSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={27} height={16} viewBox="0 0 27 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M19.704 1H7.296C3.266 1 0 4.134 0 8s3.267 7 7.296 7h12.408C23.734 15 27 11.866 27 8s-3.267-7-7.296-7"
            fill="#303030"
        />
        <path
            d="M4.232 4.599h7.86v3.793c0 .972-.54 1.87-1.418 2.357L8.162 12.14 5.651 10.75c-.879-.486-1.419-1.385-1.419-2.357z"
            fill="#FFDD2D"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.39 6.595v1.18c.168-.183.473-.306.822-.306h.38V8.84c0 .365-.103.684-.257.86h1.652c-.152-.176-.255-.495-.255-.859V7.47h.379c.35 0 .656.123.823.306v-1.18H6.388z"
            fill="#303030"
        />
        <path d="M16.58 10.378V5.921h-1.465v4.457z" fill="white" />
        <path
            d="M20.111 10.378c1.854 0 2.771-.946 2.771-2.228s-.918-2.229-2.615-2.229h-2.615v4.457h2.46zm-.148-3.39c1.005 0 1.425.431 1.425 1.162 0 .674-.418 1.189-1.425 1.189h-.898v-2.35z"
            fill="white"
        />
    </svg>
));
TinkoffIdBrandSize16Glyph.displayName = 'TinkoffIdBrandSize16Glyph';
